import { route } from '@/utils/build'
const component = (path) => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 注册全局路由
 */
export default [
  // 领取优惠券活动页
  route('/coupon_list', 'coupon_list', component('coupon/list')),
  route('/coupon_success', 'coupon_success', component('coupon/success'))
];
